/**
 * 统一埋点脚本 WAP 版
 * @author jizha.wyj <jizha.wyj@taobao.com>
 *
 * 这个文件是专为无线版准备的
 *
 **/

(function () {

    var win = window,
        doc = document,
        _k = "g_tb_aplus_loaded",
        _launch = "g_tb_aplus_launch";

    /**
     * 如果当前脚本位于 head 节点中，则稍后再执行
     * 因为 spm 埋点需要读取 <body> 标签中的属性
     */
    if (!doc.getElementsByTagName("body").length) {
        setTimeout(arguments.callee, 50);
        return;
    }

    if (win[_k]) return; // 防止本段脚本重复执行
    win[_k] = 1;

    var url_g_alicdn = '//g.alicdn.com';
    //var js_fdc_lsproxy = "//g.alicdn.com/alilog/wlog/@@VERSION/lsproxy.js";

    /**
     * 涉及到固定 key 的东东都在此管理，如对外的输出对象、window.name 值等等
     * 由于波及到全局，为了防止冲突，一般以 'ap' 作为前缀
     */
    var KEY = {
        // 沿袭老的命名
        NAME_STORAGE: {
            REFERRER: 'wm_referrer',
            REFERRER_PV_ID: 'refer_pv_id'
        }
    };

    var VERSION = "9"; // 当前 js 版本号，字符串形式
    var loc = location;
    var is_https = "https:" == loc.protocol;
    var is_in_iframe = parent !== self;
    var pathname = loc.pathname; // 当前路径，注意，这个值不包含 url 后面的参数
    //var hostsname = loc.hostname;
    //var isOffline = getMetaOffline();
    var isForbidPost = getMetaForbidPost();

    // 打点图片地址
    var use_protocol = is_https ? "https://" : "http://";
    var tblog_beacon_base = (use_protocol) + "log.mmstat.com/";
    var tblog_beacon_url = tblog_beacon_base + "m.gif";
    var tblog_data = [
        ["logtype", is_in_iframe ? 0 : 1] // 庞都 2012-06-18 需求
    ];

    var page_url = loc.href; // 当前页面的 url
    var page_url_constant = page_url.replace(/[\?#].*/g, "");
    var pvid = makePVId(); // 当前页面的 pv id
    var loc_hash = loc.hash;
    var s_goldlog = "goldlog";
    var ua = navigator.userAgent;

    // for windvane
    // see also http://gitlab.alibaba-inc.com/mtb/lib-windvane/blob/publish/1.4.2/build/windvane.debug.js
    var lib = win['lib'] || (win['lib'] = {});
    var isIOS = (/iPhone|iPad|iPod/i).test(ua);
    var isAndroid = (/Android/i).test(ua);
    var isWindVane = (/WindVane/i).test(ua);

    // 根据集团对于客户端的ua判读是否是在webview中
    // see also http://velocity.alibaba-inc.com/projects/cross-end-web/wiki/App-ua
    var osVersion = ua.match(/(?:OS|Android)[\/\s](\d+[._]\d+(?:[._]\d+)?)/i);
    var wvVersion = ua.match(/WindVane[\/\s](\d+[._]\d+[._]\d+)/);
    var WindVane = {};
    var WindVane_Native = win.WindVane_Native;
    var callbackMap = {};
    var inc = 1;
    var iframePool = [];
    var iframeLimit = 3;
    var LOCAL_PROTOCOL = 'hybrid';
    var WV_PROTOCOL = 'wv_hybrid';
    var IFRAME_PREFIX = 'iframe_';
    var SUCCESS_PREFIX = 'suc_';
    var FAILURE_PREFIX = 'err_';
    var DEFERRED_PREFIX = 'defer_';
    var PARAM_PREFIX = 'param_';
    var page_referrer = doc.referrer; // 页面来源
    // 是否在登录页面上
    var is_login_page = is_https && (
            page_url.indexOf("login.m.taobao.com") >= 0
            || page_url.indexOf("login.m.tmall.com") >= 0
        );
    var atta = !!doc.attachEvent; // 当前浏览器是否为 IE（是否支持 document.attachEvent）
    var s_attachEvent = "attachEvent";
    var s_addEventListener = "addEventListener";
    var onevent = atta ? s_attachEvent : s_addEventListener;
    var s_false = false;
    var s_true = true;
    var is_launched = s_false; // 当前页面是否已发送过日志
    var s_plain_obj = "::-plain-::"; // 一个特殊的字符串，用于标识无需编码的键值
    var refer_pv_id; // 上一个页面的 pv id
    var _head_node; // 用于保存页面的 head Node
    var _meta_nodes; // 用于保存页面 head 中的 meta 节点集合
    var acookie_cna = getCookie("cna");
    var cookie_unb = getCookie("unb");
    //var proxy_iframes = [];
    var is_use_LS_proxy = s_false;
    var s_SPM_ATTR_NAME = "data-spm";
    var s_SPM_DATA_PROTOCOL = "data-spm-protocol";
    var wh_in_page = s_false; // 页面上是否有无痕埋点
    var default_ab = "0.0";
    var page_global_spm_id_origin; // 页面的全局 spm-id，无论是不是旺铺都存在这个值
    var spm_protocol; // SPM 发送协议
    var spm_a = win["_SPM_a"];
    var spm_b = win["_SPM_b"];
    var spm_ab;
    var _microscope_data = {}; // objcet，用于保存页面上的显微镜的数据
    var _atp_beacon_data = {}; // object，用于保存页面上的 atp-beacon 的数据
    var _atp_beacon_data_params; // _atp_beacon_data 的 a=1&b=2 这样的形式，字符串
    var waitingMeta = getMetaWaiting();
    var goldlog;

    var is_ali_app;
    var is_ali_app_tb;
    var matched;
    if ((matched = ua.match(/AliApp\(([A-Z\-]+)\/([\d\.]+)\)/i))) {
        // 判断方式参考：http://gitlab.alibaba-inc.com/mtb/lib-env/blob/master/src/app.js
        is_ali_app = true;
        //appname = matched[1];
        is_ali_app_tb = matched[1] == "TB";
    }

    /**
     * nameStorage 的实现拷贝
     *
     * http://gitlab.alibaba-inc.com/codev/name-storage/tree/master
     */
    var nameStorage = (function () {

        var win = window;

        if (win['nameStorage']) {
            return win['nameStorage'];
        }

        var SCHEME = "nameStorage:";
        //var RE_NAMES = /^nameStorage:([^?]*)(?:\?(?:([^=]+)=([^&]*))*)?/g;
        var RE_PAIR = /^([^=]+)(?:=(.*))?$/;
        var Q = "?";
        var EQ = "=";
        var AND = "&";

        var encode = encodeURIComponent;
        var decode = decodeURIComponent;

        var STORAGE = {};
        var ORIGIN_NAME;

        var nameStorage = {};

        // 解析并初始化 name 数据。
        // 标准的 nameStorage 数据格式为 `nameStorage:origin-name?key=value`
        // @param {String} name.
        (function parse(name) {

            if (name && name.indexOf(SCHEME) === 0) {

                var match = name.split(/[:?]/);

                match.shift(); // scheme: match[0];
                ORIGIN_NAME = decode(match.shift()) || ""; // match[1]

                var params = match.join(""); // match[2,...]

                var pairs = params.split(AND);
                for (var i = 0, pair, key, value, l = pairs.length; i < l; i++) {
                    pair = pairs[i].match(RE_PAIR);
                    if (!pair || !pair[1]) {
                        continue;
                    }

                    key = decode(pair[1]);
                    value = decode(pair[2]) || "";

                    STORAGE[key] = value;
                }

            } else {

                ORIGIN_NAME = name || "";

            }

        })(win.name);

        // 写入数据。
        // @param {String} key, 键名。
        // @param {String} value, 键值。
        nameStorage.setItem = function (key, value) {
            if (!key || "undefined" === typeof value) {
                return;
            }
            STORAGE[key] = String(value);
            save();
        };

        // 读取数据。
        // @param {String} key, 键名。
        // @return {String} 键值。如果不存在，则返回 `null`。
        nameStorage.getItem = function (key) {
            return STORAGE.hasOwnProperty(key) ? STORAGE[key] : null;
        };

        // 移除数据。
        // @param {String} key, 键名。
        nameStorage.removeItem = function (key) {
            if (!STORAGE.hasOwnProperty(key)) {
                return;
            }
            STORAGE[key] = null;
            delete STORAGE[key];
            save();
        };

        // 清空 nameStorage。
        nameStorage.clear = function () {
            STORAGE = {};
            save();
        };

        nameStorage.valueOf = function () {
            return STORAGE;
        };

        nameStorage.toString = function () {
            var name = win.name;
            return name.indexOf(SCHEME) === 0 ? name : SCHEME + name;
        };

        // 保存数据到 window.name
        // 如果没有存储数据，则恢复原始窗口名称(window.name)。
        function save() {
            var pairs = [];
            var empty = true;
            var value;

            for (var key in STORAGE) {
                if (!STORAGE.hasOwnProperty(key)) {
                    continue;
                }
                empty = false;

                value = STORAGE[key] || "";
                pairs.push(encode(key) + EQ + encode(value));

            }

            win.name = empty ? ORIGIN_NAME : SCHEME + encode(ORIGIN_NAME) + Q + pairs.join(AND);
        }

        // addEventLister implementation
        // @param {HTMLElement} element.
        // @param {String} eventName.
        // @param {Function} handler.
        function addEventListener(element, eventName, handler) {
            if (!element) {
                return;
            }

            if (element.addEventListener) {
                element.addEventListener(eventName, handler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, function (evt) {
                    handler.call(element, evt);
                });
            }
        }

        // Save the last data for the next page.
        addEventListener(win, 'beforeunload', function () {
            save()
        });

        return nameStorage;

    })();

    /**
     * 读 referrer
     *
     * 背景：由于从 https 页面转到 http 页面后，页面的 document.referrer 属性会为空，
     * 造成部分页面的来源丢失。
     * 未登录用户点击了需要登录后才能操作的链接，如在首页点击了“我的淘宝”，
     * 会先跳到登录页面（https），然后再跳回目标页面（http）
     *
     * 因此，这儿会使用 window.name 作为辅助
     * window.name 的读写 API 和 name 值的规范定义都采用 nameStorage
     * http://gitlab.alibaba-inc.com/codev/name-storage/tree/master
     *
     * 关于 window.name 的说明，可参见：http://www.planabc.net/2008/09/01/window_name_transport/
     *
     * 另外，本 js 里的 recordValInWindowName() 方法用于 写 referrer
     */
    /**
     * 取 document.referrer，没有则从当前的 nameStorage 获取
     * 老代码下同时还取了 refer_pv_id，但是并没有拿来作什么用
     */
    page_referrer = doc.referrer || nameStorage.getItem(KEY['NAME_STORAGE']['REFERRER']) || '';

    /**
     * 判断字符串 s1 是否以字符串 s2 开头
     * @param s1 {String}
     * @param s2 {String}
     */
    function isStartWith(s1, s2) {
        return s1.indexOf(s2) == 0;
    }

    /**
     * 判断字符串 s1 是滞以字符串 s2 结尾
     * @param s1 {String}
     * @param s2 {String}
     */
    function isEndWith(s1, s2) {
        var l1 = s1.length, l2 = s2.length;
        return l1 >= l2 && s1.indexOf(s2) == (l1 - l2);
    }

    /**
     * 去掉字符串 s 前后的空格
     * @param s {String}
     */
    function trim(s) {
        return isString(s) ? s.replace(/^\s+|\s+$/g, "") : "";
    }

    function tryToDecodeURIComponent(val, default_val) {
        var v = default_val || "";
        if (val) {
            try {
                v = decodeURIComponent(val);
            } catch (e) {
            }
        }
        return v;
    }


    /**
     * object to param
     * 将一个简单对象转化为 url 参数的形式
     * 参见 arr2param() 方法
     * @param obj {Object}
     *
     */
    function obj2param(obj) {
        var a = [], k, v;
        for (k in obj)
            if (obj.hasOwnProperty(k)) {
                v = "" + obj[k];
//				a.push(k == s_plain_obj ? v : (k + "=" + encodeURIComponent(v)));
                a.push(isStartWith(k, s_plain_obj) ? v : (k + "=" + encodeURIComponent(v)));
            }
        return a.join("&");
    }

    /**
     * param to array
     * 将一个简单的形如 a=1&b=2&c=3 这样的参数转化为简单的 array 格式，如：
     * [["a", "1"], ["b", "2"], ["c", "3"]]
     *
     * @param params {String}
     */
    //function param2arr(params) {
    //	var a = params.split("&"),
    //		i = 0, l = a.length,
    //		item,
    //		arr = [];
    //	for (; i < l; i++) {
    //		item = a[i].split("=");
    //		arr.push([item.shift(), item.join("=")]);
    //	}
    //
    //	return arr;
    //}

    /**
     * array to param
     * 将一个简单的数组转化为 url 参数的形式，
     * 其中数组为
     *        [[k1, v1], [k2, v2], [k3, v3], ...]
     * 的形式。
     * 与 obj2param 相比，这个方法的好处是可以保证最后参数的顺序
     * @param arr {Array}
     * @return {String}
     */
    function arr2param(arr) {
        var a = [], k, v,
            i, len = arr.length;

        for (i = 0; i < len; i++) {
            k = arr[i][0];
            v = arr[i][1];
            a.push(isStartWith(k, s_plain_obj) ? v : (k + "=" + encodeURIComponent(v)));
        }
        return a.join("&");
    }

    function arr2obj(arr) {
        var ret = {}, k, v,
            i, len = arr.length;

        for (i = 0; i < len; i++) {
            k = arr[i][0];
            v = arr[i][1];
            ret[k] = v;
        }
        return ret;
    }


    /**
     * 根据 obj2，更新 obj1 中的属性
     * 如果一个属性在 obj2 中存在，则将它复制到 obj1 中，（这可能会覆盖掉 obj1 中的同名属性的值）
     * 注意，不会删除 obj1 中存在而 obj2 中不存在的属性
     * 执行完成之后，obj1 将会发生改变
     * @param obj1 {Object}
     * @param obj2 {Object}
     */
    //function objUpdate(obj1, obj2) {
    //	for (var k in obj2) {
    //		if (obj2.hasOwnProperty(k))
    //			obj1[k] = obj2[k];
    //	}
    //	return obj1;
    //}

    /**
     * param to object
     * 将一个简单的形如 a=1&b=2&c=3 这样的参数转化为简单的 object 格式，如：
     * {
	 *	 a: "1",
	 *	 b: "2",
	 *	 c: "3"
	 * }
     * @param params {String}
     */
    //function param2obj(params) {
    //	var a = params.split("&"),
    //		i = 0, l = a.length,
    //		item,
    //		obj = {};
    //
    //	for (; i < l; i++) {
    //		item = a[i].split("=");
    //		obj[item[0]] = tryToDecodeURIComponent(item[1]);
    //	}
    //
    //	return obj;
    //}

    /**
     * 判断字符串 s1 是否包含字符串 s2
     * @param s1 {String}
     * @param s2 {String}
     */
    function isContain(s1, s2) {
        return s1.indexOf(s2) > -1;
    }

    function isNumber(v) {
        return typeof v == "number";
    }

    function isUnDefined(v) {
        return typeof v == "undefined";
    }

    function isString(v) {
        return typeof v == "string";
    }

    function isArray(o) {
        return Object.prototype.toString.call(o) === "[object Array]";
    }

    function tryToGetAttribute(element, attr_name) {
        return element && element.getAttribute ? (element.getAttribute(attr_name) || "") : "";
    }

    function tryToGetHref(anchor) {
        /**
         * 这儿之所以要 try 一下，是因为如果 href 格式有误时，在 IE8/9 下 href 将无效，
         * 读取 anchor.href 时会直接出错。
         *
         * 例如，如果：
         *         <a href="http://shop64102844.taobao.com/search=y% 3D">测试</a>
         * 注意它缺少“?”，并且在“%”后多了一个空格
         * 在 IE8/9 下用 js 访问这个链接的 href 属性时会直接报错
         */
        var href;
        try {
            href = trim(anchor.getAttribute("href", 2));
        } catch (e) {
        }

        return href || "";
    }

    // 取得额外的引用当前 js 时在 src 后面添加的参数
    function getExParams() {
        var current_node = doc.getElementById("tb-beacon-aplus");
        return tryToGetAttribute(current_node, "exparams").replace(/&amp;/g, "&").replace(/\buserid=/, "uidaplus=");
    }

    /**
     * 取得页面上 head 中的所有 meta 元素
     */
    function getMetaTags() {
        _head_node = _head_node || doc.getElementsByTagName("head")[0];

        return _meta_nodes || (_head_node ? (_meta_nodes = _head_node.getElementsByTagName("meta")) : []);
    }

    /**
     * 解析 meta 的内容，meta 的内容形如："pageId=123; siteId=456"
     * @param s
     * @param dict
     */
    function parseMetaContent(s, dict) {
        var a = s.split(";"),
            j, a_len = a.length,
            a2, key;

        for (j = 0; j < a_len; j++) {
            a2 = a[j].split("=");
            key = trim(a2[0]);
            if (key)
                dict[key] = tryToDecodeURIComponent(trim(a2[1]));
        }
    }

    /**
     * 取得 cookie 中对应 key 的值
     * @param key {String}
     */
    function getCookie(key) {
        var cookie_val = doc.cookie.match(
            new RegExp("\\b" + key + "=([^;]+)")
        );
        return cookie_val ? cookie_val[1] : "";
    }

    /**
     * 从 url 中取出对应的 spm 参数
     * @param url {String}
     * @return {String} spm a.b.c.d.pvid，一共五位
     */
    function getSPMFromUrl(url) {
        var m = url.match(new RegExp("\\?.*spm=([\\w\\.\\-\\*]+)")),
            spm;
        //return (m && (spm = m[1]) && spm.split(".").length == 5) ? spm : null;
        return (m && (spm = m[1]) && spm.split(".").length == 4) ? spm : null;
    }

    /**
     * 生成一个用于避免缓存的随机数
     * 为了减少 url 长度，这个随机数据的长度定为 7 位，
     * 为了减少碰撞，使用 16 进制数字
     *
     * 268435456 = 2 ^ 28 = 0xfffffff + 1
     */
    function makeCacheNum() {
        return Math.floor(Math.random() * 268435456).toString(16);
    }

    /**
     * 处理页面上的 pv id
     */
    function makePVId() {

        /**
         * 生成本页的 pv id
         * pv id 只需要当前用户会话唯一即可，这儿使用一个 6 位的 16 进制数字
         */
        var key = "g_aplus_pv_id",
            rnd_strs = "",
            chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

        if (!win[key]) {
//			win[key] = Math.floor(Math.random() * 16777216).toString(16);
            while (rnd_strs.length < 6) {
                rnd_strs += chars.substr(Math.floor(Math.random() * 62), 1);
            }
            win[key] = rnd_strs;
        }

        return win[key];
    }

    /**
     * 取得 head / meta 中的 atp-beacon 的数据
     * 形如：
     * <meta name="atp-beacon" content="on=1; chksum=112233" />
     */
    function getMetaAtpData() {
        var i, meta,
            meta_nodes = getMetaTags(),
            l = meta_nodes.length,
            content;

        for (i = 0; i < l; i++) {
            meta = meta_nodes[i];
            if (tryToGetAttribute(meta, "name") == "atp-beacon") {
                content = tryToGetAttribute(meta, "content");
                parseMetaContent(content, _atp_beacon_data);
            }
        }

        _atp_beacon_data_params = obj2param(_atp_beacon_data);
    }

    /**
     * 确定 head / meta 中的 aplus-waiting 的数据
     * 形如：
     * <meta name="aplus-waiting" content="1" />
     */
    function getMetaWaiting() {
        var i, meta,
            meta_nodes = getMetaTags(),
            l = meta_nodes.length,
            content;

        for (i = 0; i < l; i++) {
            meta = meta_nodes[i];
            if (tryToGetAttribute(meta, "name") == "aplus-waiting") {
                content = tryToGetAttribute(meta, "content");
                break;
            }
        }
        return content;
    }

    /**
     * 确定 head / meta 中的 isonepage 的数据
     * 形如：
     * <meta name="isonepage" content="0" /> 表示不是onepage
     * <meta name="isonepage" content="1|http://h5.m.taobao.com/we/index.htm#detail" /> 表示是onepage
     */
    function isOnePage() {
        var i, meta,
            meta_nodes = getMetaTags(),
            l = meta_nodes.length,
            content = "-1";

        for (i = 0; i < l; i++) {
            meta = meta_nodes[i];
            if (tryToGetAttribute(meta, "name") == "isonepage") {
                content = tryToGetAttribute(meta, "content");
                break;
            }
        }
        return content;
    }

    /**
     * 取得 head / meta 中的 aplus-offline
     * 形如：
     * <meta name="aplus-offline" content="1">
     */
    function getMetaOffline() {
        var i, meta,
            meta_nodes = getMetaTags(),
            l = meta_nodes.length,
            content;

        for (i = 0; i < l; i++) {
            meta = meta_nodes[i];
            if (tryToGetAttribute(meta, "name") == "aplus-offline") {
                content = tryToGetAttribute(meta, "content");
                break;
            }
        }

        return content;
    }

    /**
     * 主动禁止lsproxy方案
     * 形如：
     * <meta name="aplus-offline" content="1">
     */
    function getMetaForbidPost() {
        var i, meta,
            meta_nodes = getMetaTags(),
            l = meta_nodes.length,
            content;

        for (i = 0; i < l; i++) {
            meta = meta_nodes[i];
            if (tryToGetAttribute(meta, "name") == "aplus-forbidpost") {
                content = tryToGetAttribute(meta, "content");
                break;
            }
        }

        return content;
    }

    /**
     * 生成一个 url 的 chk_sum
     * @param url
     */
    function makeChkSum(url) {
        url = (url || "").split("#")[0].split("?")[0];

        var len = url.length,
            hash = function (s) {
                var i, l = s.length, key = 0;
                for (i = 0; i < l; i++) {
                    key = key * 31 + s.charCodeAt(i);
                }
                return key;
            };

        return len ? hash(len + "#" + url.charCodeAt(len - 1)) : -1;
    }

    /**
     * DOMReady 方法，
     */
    function onDOMReady(f) {

        var kissy = win["KISSY"];
        if (kissy) {
            // 如果页面上有 KISSY，使用 KISSY 的方法
            kissy.ready(f);

        } else if (win.jQuery) {
            // 如果页面上存在 jQuery，使用 jQuery 的方法
            jQuery(doc).ready(f);

        } else {

            // 判断页面是否已经加载完成
            if (doc.readyState === "complete") {
                // 如果页面已经加载完成，直接执行函数 f
                f();

            } else {
                // 使用 window 的 onload 事件
                addEventListener(win, "load", f);
            }

        }
    }

    /**
     * 写 referrer
     *
     * 在 window.name 中记录当前页面的 url，以便下一个页面读取
     * window.name 的读写 API 和 name 值的规范定义都采用 nameStorage
     * http://gitlab.alibaba-inc.com/codev/name-storage/tree/master
     */
    function recordValInWindowName() {

        var referrer,
            referrer_pv_id;

        // 仅在 top 页面才做这个操作
        // 仅在 https 页面在 window.name 中记录下 referrer 的值
        if (is_in_iframe || !is_https) {
            return;
        }

        /**
         * 如果是在登录页面上，并且已经记录了一个 referrer，则这儿去掉 referrer 参数
         * 因为，如果用户是从 A 页面点击到 B 页面，中间经过了登录页面，
         * 后台在还原路径时，只需要知道 A -> B，而不需要知道 A -> login -> B
         */
        if (is_login_page && page_referrer) {
            referrer = page_referrer;
            referrer_pv_id = nameStorage.getItem(KEY['NAME_STORAGE']['REFERRER_PV_ID']);
        } else {
            referrer = page_url;
            referrer_pv_id = pvid;
        }

        nameStorage.setItem(KEY['NAME_STORAGE']['REFERRER'], referrer);
        nameStorage.setItem(KEY['NAME_STORAGE']['REFERRER_PV_ID'], referrer_pv_id);

    }


    /**
     * 绑定事件
     * @param obj {Element} DOM 元素
     * @param event_type
     * @param f
     */
    function addEventListener(obj, event_type, f) {

        // 绑定 document 的 mousedown 事件
        obj[onevent](
            (atta ? "on" : "") + event_type,
            function (e) {
                e = e || win.event;
                var el = e.target || e.srcElement;

                f(e, el);
            },
            s_false
        );

    }

    function atp_inIframeException() {

        var i, l,
            atp_count_paths = [ // wap 版去掉白名单
            ];

        for (i = 0, l = atp_count_paths.length; i < l; i++) {
            if (pathname.indexOf(atp_count_paths[i]) != -1)
                return s_true;
        }

        // 如果来源页面不是 taobao 页面，则：
        var re = /^https?:\/\/[\w\.]+\.(taobao|tmall|etao|tao123|juhuasuan)\.com/i;
        return !re.test(page_referrer);
    }

    /**
     * 清理打点参数
     * 将所有值为空的参数去掉（aplus除外）；
     * 如果有重复的参数，只保留最后一个
     * @param data {Array}
     */
    function cleanParams(data) {
        var new_params = [],
            i,
            item,
            keys = {},
            k, v;

        for (i = data.length - 1; i >= 0; i--) {
            item = data[i];
            k = item[0];
            if (k != s_plain_obj && keys.hasOwnProperty(k)) continue;
            v = item[1];
            if (k == "aplus" || v != "") {
                new_params.unshift([k, v]);
                keys[k] = 1;
            }
        }

        return new_params;
    }

    /**
     * 清理windvane打点参数，去除：
     * logtype
     * cache
     * scr
     * ::-plain-xxx
     * spm-cnt
     * @param data
     */
    function cleanParamsForWindvane(data) {
        var new_params = [],
            i,
            item,
            k, v,
            excludeParms = {
                "logtype": true,
                "cache": true,
                "scr": true,
                "spm-cnt": true
            };

        for (i = data.length - 1; i >= 0; i--) {
            item = data[i];
            k = item[0];
            v = item[1];
            if (isStartWith(k, s_plain_obj) || excludeParms[k]) {
                continue;
            }
            new_params.unshift([k, v]);
        }
        return new_params;
    }

    /**
     * 发送打点数据
     * @param url {String}
     * @param data {Object|Array}
     * @return {*}
     */
    function tblogSend(url, data) {

        var beacon_url, obj, new_data;
        if (!data) return;

        data = cleanParams(data);

        // if AliApp use windVane
        if (isWindVane) {
            new_data = cleanParamsForWindvane(data);
            var windVaneData = {};
            var spm_url = getSPMFromUrl(page_url), // 当前访问页面的 url 里的 spm
                spm_pre = getSPMFromUrl(page_referrer),
                extendargs; // 来源地址里的 spm

            var content = isOnePage(),
                arr_content = content.split("|"),
                isonepage = arr_content[0],
                urlpagename = arr_content[1] ? arr_content[1] : "";

            try {
                obj = arr2obj(new_data);
                extendargs = JSON.stringify(obj);
                if (extendargs == "{}") {
                    extendargs = "";
                }
            } catch (e) {
                extendargs = "";
            }

            windVaneData["functype"] = "2001";
            windVaneData["urlpagename"] = urlpagename;
            windVaneData["url"] = loc.href;
            windVaneData["spmcnt"] = (spm_ab || "0.0") + ".0.0";
            windVaneData["spmpre"] = spm_pre || "";
            windVaneData["lzsid"] = "";
            windVaneData["cna"] = acookie_cna || "";
            windVaneData["extendargs"] = extendargs;
            windVaneData["isonepage"] = isonepage;

            WindVane.call("WVTBUserTrack", "toUT", windVaneData);

            win[s_goldlog]['windVaneData'] = windVaneData;

        }

        if (!isWindVane || !is_ali_app_tb) {
            // 非 WindVane 或不是 AliApp(TB 时发送 h5 日志
            beacon_url = goldlog.send(url, data);
        }

        return beacon_url;
    }

    function mkPlainKey() {
        return s_plain_obj + Math.random();
    }

    /**
     * 在当前页面添加一个 js
     * @param src
     * @param [https_src]
     */
    function addScript(src, https_src) {
        var s = "script";
        var t = doc.createElement(s);
        t.type = "text/javascript";
        t.async = true;
        t.src = is_https ? (https_src || src) : src;
        var m = doc.getElementsByTagName(s)[0];
        //doc.getElementsByTagName("head")[0].appendChild(t);
        m.parentNode.insertBefore(t, m);
    }

    //function createIframe(src, name) {
    //	var iframe = document.createElement("iframe");
    //	iframe.style.width = "1px";
    //	iframe.style.height = "1px";
    //	iframe.style.position = "absolute";
    //	iframe.style.display = "none";
    //	iframe.src = src;
    //	if (name) iframe.name = name;
    //
    //	var body = document.getElementsByTagName("body")[0];
    //	body.appendChild(iframe);
    //
    //	return iframe;
    //}

    /**
     * 检测localStorage是否可用，修复IOS7下的bug
     * #详见 http://stackoverflow.com/questions/21159301/quotaexceedederror-dom-exception-22-an-attempt-was-made-to-add-something-to-st
     */
    function checkLS() {
        var isOK = false;
        if ('localStorage' in win && win['localStorage'] != null) {
            try {
                localStorage.setItem("test", "test");
                localStorage.removeItem("test");

                isOK = true;
            } catch (e) {
            }
        }
        return isOK;
    }

    /**
     * 是否使用localStorage代理
     * @return {Boolean}
     */
    function isUseLSProxy() {
        // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_8_2) AppleWebKit/536.26.17 (KHTML, like Gecko) Version/6.0.2 Safari/536.26.17

        if (is_https || is_ali_app) return false;

        var a = ua.split(" Safari/");
        if (a.length != 2) return false;
        a[1] = trim(a[1]);

//		return true; // 仅用于测试
        return !isForbidPost &&
            checkLS() &&
            win.postMessage && !a[1].match(/[\d\.]+?\s+.+/) &&  // 排除ua后带有自定义参数的，如 Mozilla/5.0 (Linux; U; Android 4.1.1; zh-cn; MI 2 Build/JRO03L) AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30 WindVane/2.6.0 TBANDROID/600000@taobao_android_3.9.5
            ua.indexOf("AppleWebKit") > -1 &&
            ua.match(/\bVersion\/\d+/) && !ua.match(/\bChrome\/\d+/) && !ua.match(/TencentTraveler|QQBrowser/) && // 排除qq浏览器
            !ua.match(/UCBrowser|UCWEB/); // 排除uc浏览器
    }

    /**
     * 使用localStorage代理
     * 调用这个方法时，一定是新浏览器，一定支持addEventListener等方法
     */
    //function useLSProxy(data) {
    //	var src = "//mmstat.alicdn.com/aplus-proxy.html?v=20130115";
    //	var iframe = createIframe(src, JSON.stringify(data));
    //	proxy_iframes.push(iframe);
    //}

    /**
     * 根据url以及参数，拼装一个更长的url
     //* @param url {String}
     //* @param data {Object|Array}
     */
    //function makeUrl(url, data) {
    //	var link_char = url.indexOf("?") == -1 ? "?" : "&",
    //		param_data = data ? (
    //			isArray(data) ? arr2param(data) : obj2param(data)
    //		) : "";
    //
    //	return param_data ? (url + link_char + param_data) : url;
    //}

    function getSPMProtocolFromMeta() {

        var metas = getMetaTags(),
            i, l,
            meta,
            meta_name;

        for (i = 0, l = metas.length; i < l; i++) {
            meta = metas[i];
            meta_name = tryToGetAttribute(meta, "name");
            if (meta_name == s_SPM_ATTR_NAME) {
                spm_protocol = tryToGetAttribute(meta, s_SPM_DATA_PROTOCOL);
//				spm_protocol = spm_protocol == "i" ? "i" : "u";
            }
        }

    }

    function getMetaSPMData(key) {
        var metas = getMetaTags(),
            i, l, a,
            meta, meta_name,
            tmp;

        if (metas) {
            for (i = 0, l = metas.length; i < l; i++) {
                meta = metas[i];
                meta_name = tryToGetAttribute(meta, "name");
                if (meta_name == key) {
                    page_global_spm_id_origin = tryToGetAttribute(meta, "content");

                    // 处理 spm 协议
                    if (page_global_spm_id_origin.indexOf(":") >= 0) {
                        a = page_global_spm_id_origin.split(":");
                        spm_protocol = a[0] == "i" ? "i" : "u";
                        page_global_spm_id_origin = a[1];
                    }
                    tmp = tryToGetAttribute(meta, s_SPM_DATA_PROTOCOL);
                    if (tmp) {
                        spm_protocol = (tmp == "i" ? "i" : "u");
                    }

                    spm_ab = page_global_spm_id_origin;

                    return s_true;
                }
            }
        }

        return s_false;
    }

    /**
     * 如果 value ，则将 value 添加到 data 中
     * @param data {Array}
     * @param key_value_pairs {Array}
     */
    function ifAdd(data, key_value_pairs) {
        var i, l = key_value_pairs.length,
            item,
            k, v;

        for (i = 0; i < l; i++) {
            item = key_value_pairs[i];
            k = item[0];
            v = item[1];
            if (v) {
                data.push([k, v]);
            }
        }
    }

    // for windvane
    // see also http://gitlab.alibaba-inc.com/mtb/lib-windvane/blob/publish/1.4.2/build/windvane.debug.js
    function compareVersion(v1, v2) {
        v1 = v1.toString().split('.');
        v2 = v2.toString().split('.');

        for (var i = 0; i < v1.length || i < v2.length; i++) {
            var n1 = parseInt(v1[i], 10), n2 = parseInt(v2[i], 10);

            if (window.isNaN(n1)) {
                n1 = 0;
            }
            if (window.isNaN(n2)) {
                n2 = 0;
            }
            if (n1 < n2) {
                return -1;
            }
            else if (n1 > n2) {
                return 1;
            }
        }
        return 0;
    }

    function callback(func, result) {
        if (isAndroid && compareVersion(osVersion, '2.4.0') < 0) { //判断在android且2.3.x下，使用延时执行
            setTimeout(function () {
                func && func(result);
            }, 1);
        } else {
            func && func(result);
        }
    }

    if (osVersion) {
        osVersion = (osVersion[1] || '0.0.0').replace(/\_/g, '.');
    } else {
        osVersion = '0.0.0';
    }

    if (wvVersion) {
        wvVersion = (wvVersion[1] || '0.0.0').replace(/\_/g, '.');
    } else {
        wvVersion = '0.0.0';
    }

    /**
     * 取得全局 spm id
     * 以 init_ 开头的函数是页面加载时就会执行的
     * 步骤如下：
     * 1、如果页面上存在无痕埋点，则使用无痕埋点数据
     *        spm_a = window._SPM_a;
     *        spm_b = window._SPM_b;
     *        spm_protocol 从 head meta 中取
     *
     * 2、在 head 中查找
     *         <meta name="spm-id" content="[Protocol:]xx.xx" />
     *        或：<meta name="spm-id" content="[Protocol:]xx" />
     *        或：<meta name="data-spm" content="[Protocol:]xx" />
     * 如果找到，则；
     *        如果其内容不以“110”开头，则使用；
     *        否则，返回空（旺铺页面没有全局 spm-id） 2012-02-13 补庵、大渡需求
     *
     * 3、在 body 标签中查找 spm id 的第 2 位，如果找到，则使用（2012-06-06）
     * @see: http://baike.corp.taobao.com/index.php/Spm%E5%9F%8B%E7%82%B9
     *
     * 4、否则，返回“0.0”
     */
    function init_getGlobalSPMId() {

        if (!isUnDefined(spm_ab)) return spm_ab;

        if (spm_a && spm_b) {
            // 如果页面上存在 _SPM_a、_SPM_b，表示页面上有无痕埋点
            spm_a = spm_a.replace(/^{(\w+)}$/g, "$1");
            spm_b = spm_b.replace(/^{(\w+)}$/g, "$1");
            wh_in_page = s_true;
            spm_ab = spm_a + "." + spm_b;
            getSPMProtocolFromMeta();

            goldlog.spm_ab = [spm_a, spm_b];

            return spm_ab;
        }

        var head = doc.getElementsByTagName("head")[0],
            a;

        getMetaSPMData(s_SPM_ATTR_NAME) || getMetaSPMData("spm-id");

        // 不存在对应的 meta
        spm_ab = spm_ab || default_ab;
        /**
         * 如果页面上不存在 spm id 的第一位，则返回空值
         */
        if (!spm_ab) return spm_ab;

        /**
         * 从 body 标签中获取第二位
         * 形如：<body data-spm="1000484">...</body>
         */
        var body = doc.getElementsByTagName("body");
        var spm_b_val;
        a = spm_ab.split(".");
        goldlog.spm_ab = a;
        body = body && body.length ? body[0] : null;
        if (body) {
            spm_b_val = tryToGetAttribute(body, s_SPM_ATTR_NAME);
            if (spm_b_val) {
                // body 标签中存在 spm 第二位
                spm_ab = a[0] + "." + spm_b_val;
                goldlog.spm_ab = [a[0], spm_b_val];
            } else if (a.length == 1) {
                // 如果没有指定第二位，则a、b都取0
                spm_ab = default_ab;
            }
        }


        return spm_ab;
    }

    function init_loadScripts() {

        // 添加 laiwang 埋点脚本
        var lwhost = "laiwang",
            lwlog_path = "/ilw/a/lwlog.js?v=140709";
        if (isContain(loc.href.split("?")[0], lwhost)) {
            addScript(url_g_alicdn + lwlog_path);
        }

    }

    // see also http://gitlab.alibaba-inc.com/mtb/lib-windvane/blob/publish/1.4.2/build/windvane.debug.js
    function init_windVane() {

        var WV_Core = {
            call: function (obj, method, param, successCallback, failureCallback, timeout) {
                var sid;
                var deferred;

                if (lib.promise) {
                    deferred = lib.promise.deferred();
                }

                if (timeout > 0) {
                    sid = setTimeout(function () {
                        WV_Core.onFailure(sid, {ret: 'TIMEOUT'});
                    }, timeout);
                } else {
                    sid = WV_Private.getSid();
                }
                // 让windvane可以取得sid
                param["sid"] = sid;

                WV_Private.registerCall(sid, successCallback, failureCallback, deferred);

                if (isAndroid) {
                    if (compareVersion(wvVersion, '2.7.0') >= 0) {   // android下，windvane的版本大于2.7.0，则用prompt的方式
                        WV_Private.callMethodByPrompt(obj, method, WV_Private.buildParam(param), sid + '');
                    } else if (WindVane_Native && WindVane_Native.callMethod) { // 向下兼容，调用注册的JS对象方法
                        WindVane_Native.callMethod(obj, method, WV_Private.buildParam(param), sid + '');
                    }
                } else if (isIOS) { // iOS用iframe的协议发送
                    WV_Private.callMethodByIframe(obj, method, WV_Private.buildParam(param), sid + '');
                }

                if (deferred) {
                    return deferred.promise();
                }
            },

            fireEvent: function (eventname, eventparam) {
                // 当native需要通知js的时候（通信），用触发事件的方式进行
                var ev = doc.createEvent('HTMLEvents');
                ev.initEvent(eventname, false, true);
                ev.param = WV_Private.parseParam(eventparam);
                doc.dispatchEvent(ev);
            },

            getParam: function (sid) {
                // 因为ios下iframe协议，对于url长度有限制，所以增加一个参数的map。
                return WV_Private.params[PARAM_PREFIX + sid] || '';
            },

            // {ret:'SUCCESS', value:{'a':1}}
            onSuccess: function (sid, msg) {
                // native代码处理成功后，调用该方法来通知js
                clearTimeout(sid);
                var call = WV_Private.unregisterCall(sid);
                var success = call.success;
                var deferred = call.deferred;
                var param = WV_Private.parseParam(msg);

                callback(function (value) {
                    success && success(value);
                    deferred && deferred.resolve(value);
                }, param.value || param);
                WV_Private.onComplete(sid);
            },


            // {ret:'ERROR'}
            onFailure: function (sid, msg) {
                // native代码处理成功后，调用该方法来通知js
                clearTimeout(sid);
                var call = WV_Private.unregisterCall(sid);
                var failure = call.failure;
                var deferred = call.deferred;
                var param = WV_Private.parseParam(msg);

                callback(function (value) {
                    failure && failure(value);
                    deferred && deferred.reject(value);
                }, param);
                WV_Private.onComplete(sid);
            }
        };

        var WV_Private = {
            params: {},

            buildParam: function (obj) {
                if (obj && typeof obj === 'object') {
                    //obj.bridgeVersion = VERSION;
                    return JSON.stringify(obj);
                } else {
                    return obj || '';
                }
            },

            parseParam: function (str) {
                var obj;
                if (str && typeof str === 'string') {
                    try {
                        obj = JSON.parse(str);
                    } catch (e) {
                        obj = eval('(' + str + ')');
                    }
                } else {
                    obj = str || {};
                }

                return obj;
            },

            getSid: function () {
                return Math.floor(Math.random() * (1 << 50)) + '' + inc++;
            },

            registerCall: function (sid, successCallback, failedCallback, deferred) {
                if (successCallback) {
                    callbackMap[SUCCESS_PREFIX + sid] = successCallback;
                }

                if (failedCallback) {
                    callbackMap[FAILURE_PREFIX + sid] = failedCallback;
                }

                if (deferred) {
                    callbackMap[DEFERRED_PREFIX + sid] = deferred;
                }
            },

            unregisterCall: function (sid) {
                var sucId = SUCCESS_PREFIX + sid;
                var failId = FAILURE_PREFIX + sid;
                var defId = DEFERRED_PREFIX + sid;
                var call = {
                    success: callbackMap[sucId],
                    failure: callbackMap[failId],
                    deferred: callbackMap[defId]
                };

                delete callbackMap[sucId];
                delete callbackMap[failId];
                if (call.deferred) {
                    delete callbackMap[defId];
                }
                return call;
            },

            useIframe: function (sid, url) {
                //this.ifUseIframe || (this.ifUseIframe = true);

                var iframeid = IFRAME_PREFIX + sid;
                var iframe = iframePool.pop();

                if (!iframe) {
                    iframe = doc.createElement('iframe');
                    iframe.setAttribute('frameborder', '0');
                    iframe.style.cssText = 'width:0;height:0;border:0;display:none;';
                }

                iframe.setAttribute('id', iframeid);
                iframe.setAttribute('src', url);

                if (!iframe.parentNode) {
                    setTimeout(function () {
                        doc.body.appendChild(iframe);
                    }, 5);
                }
            },

            retrieveIframe: function (sid) {
                //if (!this.ifUseIframe) return;
                var iframeid = IFRAME_PREFIX + sid;
                var iframe = doc.querySelector('#' + iframeid);

                if (iframePool.length >= iframeLimit) {
                    doc.body.removeChild(iframe);
                } else {
                    iframePool.push(iframe);
                }
            },

            callMethodByIframe: function (obj, method, param, sid) {
                // [for protocol] hybrid://objectName:sid/methodName
                var p = {"selfParam=1": 1, "sid": this.parseParam(param)["sid"]};
                p = this.buildParam(p);
                var src = LOCAL_PROTOCOL + '://' + obj + ':' + sid + '/' + method + '?' + p;
                this.params[PARAM_PREFIX + sid] = param;
                this.useIframe(sid, src);
            },

            callMethodByPrompt: function (obj, method, param, sid) {
                var title = LOCAL_PROTOCOL + '://' + obj + ':' + sid + '/' + method + '?' + param;
                var val = WV_PROTOCOL + ':';
                this.params[PARAM_PREFIX + sid] = param;
                window.prompt(title, val);
            },

            onComplete: function (sid) {
                if (isIOS) {    //iOS下回收iframe
                    this.retrieveIframe(sid);
                }
                delete this.params[PARAM_PREFIX + sid];
            }
        };

        for (var key in WV_Core) {
            // 在goldlog中对外暴露windvane接口
            win[s_goldlog][key] = WindVane[key] = WV_Core[key];
        }
    }

    /**
     * 记录日志的基本方法
     */
    goldlog = {

        version: VERSION,
        referrer: page_referrer,
        _d: {}, // 页面上可能会用到的临时数据
        _microscope_data: _microscope_data,

        getCookie: getCookie,
        tryToGetAttribute: tryToGetAttribute,
        tryToGetHref: tryToGetHref,
        isNumber: isNumber,

        /**
         * 由于一些原因，这里暴露出 nameStorage
         */
        nameStorage: nameStorage,

        /**
         * 发送打点
         * @param data
         */
        launch: function (data) {

            if (win[_launch]) return;
            win[_launch] = s_true;

            var k, v,
                isbeta,
                exparams = getExParams(),
                hasMeta = (waitingMeta == 1);

            // 2014-01-10 庞都需求，根据不同发送方式指定版本号
            if (data && data.isWait && hasMeta) {
                isbeta = 7;
                delete data.isWait;
            } else if (hasMeta) {
                isbeta = 8;
            } else if (!hasMeta) {
                isbeta = 5;
            }

            for (k in data) {
                if (data.hasOwnProperty(k) && (v = data[k])) {
                    tblog_data.push([k, v]);
                }
            }
            // 2014-01-10 庞都需求，根据不同发送方式指定版本号
            tblog_data.push(["isbeta", isbeta]);

            // 2012-08-21 一啸需求，保证 exParams 参数在最后
            tblog_data.push([mkPlainKey(), !!exparams ? exparams : "aplus"]);

            ifAdd(tblog_data, [
                ["urlokey", loc_hash],
                ["aunbid", cookie_unb]
            ]);

            /**
             * 这儿将 atp 请求的 src 放到了一个全局变量中，以便某些特殊需求使用，
             * 例如某些动态加载的页面需要算一个 PV，这时可以修改下这个地址的 cache 值，再发送一次
             */
			win["g_aplus_pv_req"] = tblogSend(tblog_beacon_url,tblog_data); 
        },
		/**
		 *
		 * @param url {String}
		 * @param data {Object|Array}
		 * @return {String}
		 */
		send: function (url, data) {

			var img = new Image(),
				rnd_id = "_img_" + Math.random(),
				link_char = url.indexOf("?") == -1 ? "?" : "&",
				src,
				param_data = data ? (
					isArray(data) ? arr2param(data) : obj2param(data)
					) : "";

			// 在全局变量中引用 img，防止 img 被垃圾回收机制过早回收造成请求发送失败
			// 参考：http://hi.baidu.com/meizz/blog/item/a0f4fc0ae9d8be1694ca6b05.html
			win[rnd_id] = img;

			img.onload = img.onerror = function () {
				win[rnd_id] = null;
			};

			img.src = src = param_data ? (url + link_char + param_data) : url;
			img = null; // 删除临时变量的引用

			return src;
		},

		/**
		 * 黄金令箭的方法
		 * @param logkey {String} 令箭 ID （如 /tmallac.1.1，必须以“/”开头）或图片地址（如 1.gif），曝光日志的 logkey 为ac，
		 * 		常规日志的 logkey 是 *.gif，黄金令箭的 logkey 开头一定是“/”
		 * @param gmkey {String}
		 * @param gokey {String} 形如 a=1&b=2&c=ccc
		 * @param chksum {Number}
		 */
		record: function (logkey, gmkey, gokey, chksum) {

			//----------------- 航旅独有的埋点逻辑 start -----------------
			if(window._prism_lk){
				var _prism_lk = encodeURIComponent(JSON.stringify(window._prism_lk));
				if(gokey){
					gokey = gokey + ('&_prism_lk=' + _prism_lk);
				}
			}
			//----------------- 航旅独有的埋点逻辑 end -------------------

			chksum = arguments[3] || "";
			var url, link_char = "?", ignore_chksum = s_false,
				log_type,
				wgo_url = "//wgo.mmstat.com/",
				wgm_url = "//wgm.mmstat.com/",
                cacheNum = makeCacheNum();

            var hjlj_params = "",
                spm_cnt = (spm_ab || "0.0") + ".0.0";

            if (logkey == "ac") {
                // 曝光日志
                url = "//ac.mmstat.com/1.gif";
                ignore_chksum = isStartWith(chksum, "A") && (chksum.substring(1) == makeChkSum(gmkey));

            } else if (isStartWith(logkey, "/")) {
                // 黄金令箭
                ignore_chksum = isStartWith(chksum, "H") && (chksum.substring(1) == makeChkSum(logkey));
                url = wgo_url + logkey.substring(1);
                log_type = 2;
                hjlj_params += "&spm-cnt=" + spm_cnt;

            } else if (isEndWith(logkey, ".gif")) {
                // 常规日志
                url = tblog_beacon_base + logkey;

            } else if (logkey == "aplus") {
                // 庞都 2013-11-21 需求
                url = wgm_url + "mx.gif";
                log_type = 1;

            } else {
                // 不合法的 code
                return s_false;
            }

			if (!ignore_chksum && chksum != "%" && makeChkSum(page_url_constant) != chksum) {
				// chksum 不合法
				return s_false;
			}
			//--------- 航旅独有 在黄金令箭打点日志带上URL的查询参数 start --------

			var urlParams = location.search.slice(1);
			//--------- 航旅独有 在黄金令箭打点日志带上URL的查询参数 end ----------

            gokey = (gokey || "")
                + (urlParams ? "&_h5params=" + encodeURIComponent(urlParams) : "") //航旅独有
                + (loc_hash ? "&urlokey=" + encodeURIComponent(loc_hash) : "")
                + (cookie_unb ? "&aunbid=" + encodeURIComponent(cookie_unb) : "");
            if (gokey.indexOf("&") == 0)
                gokey = gokey.substr(1);

			url += link_char + "cache=" + cacheNum
				+ "&gmkey=" + encodeURIComponent(gmkey)
				+ "&gokey=" + encodeURIComponent(gokey)
				+ "&cna=" + acookie_cna // 一啸 2012-08-20 需求
				+ "&isbeta=" + VERSION
                + hjlj_params
            ;

            if (log_type) {
                url += "&logtype=" + log_type; // 庞都 2012-07-30 需求
            }

            // if AliApp use windVane
            if (isWindVane) {
                var windVaneData = {},
                    data = {
                        gmkey: gmkey,
                        gokey: gokey,
                        isbeta: VERSION
                    },
                    logkeyargs;

                var content = isOnePage(),
                    arr_content = content.split("|"),
                    isonepage = arr_content[0],
                    urlpagename = arr_content[1] ? arr_content[1] : "";

                try {
                    logkeyargs = JSON.stringify(data);
                    if (logkeyargs == "{}") {
                        logkeyargs = "";
                    }
                } catch (err) {
                    logkeyargs = "";
                }

                windVaneData["functype"] = "2101";
                windVaneData["logkey"] = logkey;
                windVaneData["logkeyargs"] = logkeyargs;
                windVaneData["urlpagename"] = urlpagename;
                windVaneData["url"] = loc.href;
                windVaneData["cna"] = acookie_cna || "";
                windVaneData["extendargs"] = "";
                windVaneData["isonepage"] = isonepage;

                WindVane.call("WVTBUserTrack", "toUT", windVaneData);
            }

            return goldlog.send(url);
        },

        sendPV: function () {

            // 需要将tblog之前的数据清空
            tblog_data = [
                ["logtype", is_in_iframe ? 0 : 1] // 庞都 2012-06-18 需求
            ];

            // spm_ab 必须清空， 否则init_getGlobalSPMId中会不再去取
            spm_ab = undefined;
            spm_ab = init_getGlobalSPMId();

            sendPV(false);
		}
	};
    win[s_goldlog] = goldlog;

    // 初始化加载脚本
    init_getGlobalSPMId();
    init_loadScripts();
    // 2014-05-07 webview需求
    // 排除Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D201 AliApp(AP/8.1.0.042401) AlipayClient/8.1.0.042401
    if (isWindVane) {
        init_windVane();
    }


    /**
     * 取得打点参数
     */
    function sendPV(auto) {

        var data,
            spm_url = getSPMFromUrl(page_url), // 当前访问页面的 url 里的 spm
            spm_pre = getSPMFromUrl(page_referrer), // 来源地址里的 spm
            tracknick = getCookie("tracknick"),
            isbeta,
            exparams = getExParams();

        is_use_LS_proxy = isUseLSProxy();
        loc_hash = loc.hash;

        if (loc_hash && loc_hash.indexOf("#") == 0) {
            loc_hash = loc_hash.substr(1);
        }


        // 监听子iframe的消息
//		if (is_use_LS_proxy && win.addEventListener && win.JSON) {
//			win.addEventListener("message", function (event) {
//				var data = event.data;
//
//				function getRootDomain() {
//					var a = hostsname.split(".");
//					var len = a.length;
//					if (len > 1) {
//						return a[len-2] + "." + a[len-1];
//					} else {
//						return hostsname;
//					}
//				}
//
//				// todo 删除临时的 iframe
////				setTimeout(function () {
////					var ifr = proxy_iframes.shift();
////					if (ifr)
////						doc.removeChild(ifr);
////				}, 200);
//
//				try {
//					data = JSON.parse(data);
//				} catch (e) {
//					return;
//				}
//
//				var item, cookie, k;
//				for (var i = 0, l = data.length; i < l; i ++) {
//					item = data[i];
//					k = item.k;
//					cookie = encodeURIComponent(k) + "="
//						// 历史原因，cna这个cookie不编码
//						+ (k == "cna" ? item.v : encodeURIComponent(item.v))
////						+ item.v
////						+ encodeURIComponent(item.v)
//						+ "; domain=." + getRootDomain()
//						+ "; path=/"
//						+ "; expires=" + (new Date(item.t)).toGMTString();
//					doc.cookie = cookie;
//				}
//			});
//		}

        if (!is_in_iframe || atp_inIframeException()) { // 不在框架中 or 包含指定路径

            if (waitingMeta == 1) {
                isbeta = 7;
            } else {
                isbeta = VERSION;
            }

            // 记录相关参数
            data = [
                [mkPlainKey(), "title=" + escape(doc.title)],
                ["pre", page_referrer],

                ["cache", makeCacheNum()],
                ["scr", screen.width + "x" + screen.height],
                ["isbeta", isbeta]
//				ul_chk: url_chk_sum // 发送 ul_chk 验证码

            ];

            if (acookie_cna) {
                data.push([mkPlainKey(), "cna=" + acookie_cna]);
            }
            if (tracknick) {
                data.push([mkPlainKey(), "nick=" + tracknick]);
            }
            //data.push(["spm-cnt", (spm_ab || "0.0") + ".0.0." + pvid]);
            data.push(["spm-cnt", (spm_ab || "0.0") + ".0.0"]);
            ifAdd(data, [
                ["spm-url", spm_url],
                ["spm-pre", spm_pre]
            ]);

            tblog_data = tblog_data.concat(data);

            /**
             * 这儿将 atp 请求的 src 放到了一个全局变量中，以便某些特殊需求使用，
             * 例如某些动态加载的页面需要算一个 PV，这时可以修改下这个地址的 cache 值，再发送一次
             */
            if (isbeta == 7) {
                setTimeout(function () {
                    goldlog.launch({isWait: true});
                }, 6000);
            } else {
                // 2012-08-21 一啸需求，保证 exParams 参数在最后
                // 如果有exparams参数，直接使用，没有则直接用aplus间隔参数
                tblog_data.push([mkPlainKey(), !!exparams ? exparams : "aplus"]);

                ifAdd(tblog_data, [
                    ["urlokey", loc_hash],
                    ["aunbid", cookie_unb]
                ]);

                // add params
                if (!auto) {
                    //var autoArr = [["auto", "0"]];
                    ifAdd(tblog_data, [
                        ["auto", "0"]
                    ]);
//					if (typeof params == "string") {
//						ifAdd(tblog_data, param2arr(params).concat(autoArr));
//					} else if (typeof params == "object") {
//						ifAdd(tblog_data, param2arr(obj2param(params)).concat(autoArr));
//					}
                }

                win["g_aplus_pv_req"] = tblogSend(tblog_beacon_url, tblog_data);
            }
        }

        if (is_in_iframe) {
            /**
             * 满足开启规则的 iframe 向 http://ac.mmstat.com/1.gif 增加一个打点（不影响原来的白名单规则）
             *
             */
            getMetaAtpData();

            /**
             * iframe 例外
             */
            var chksum,
                on = _atp_beacon_data["on"],
                url = (on == "1" ? "//ac.mmstat.com/y.gif" : tblog_beacon_url);
            if (
                (on == "1" || on == "2")
                && (chksum = _atp_beacon_data["chksum"])
                && chksum === makeChkSum(page_url).toString()
            ) {
                tblogSend(url, tblog_data);
            }
        }

        addEventListener(win, "beforeunload", function () {
            recordValInWindowName();
        });
    }

    sendPV(true);

})();




/*****************
 ** WEBPACK FOOTER
 ** ./components/wlog/src/aplus_wap.js
 ** module id = 15
 ** module chunks = 0
 **/